import React from "react";
import { ArrayProperty, MapProperty, Property, StringProperty, NumberProperty, BooleanProperty, DateProperty, GeopointProperty, ReferenceProperty, RelationProperty, VectorProperty, BinaryProperty } from "./properties";import { BaseProperty } from "./properties";

type CMSBasePropertyNoName = Omit<BaseProperty, "name">;

export type ConfigProperty =
    | (Omit<StringProperty, "name"> & { name?: string } & CMSBasePropertyNoName)
    | (Omit<NumberProperty, "name"> & { name?: string } & CMSBasePropertyNoName)
    | (Omit<BooleanProperty, "name"> & { name?: string } & CMSBasePropertyNoName)
    | (Omit<DateProperty, "name"> & { name?: string } & CMSBasePropertyNoName)
    | (Omit<GeopointProperty, "name"> & { name?: string } & CMSBasePropertyNoName)
    | (Omit<ReferenceProperty, "name"> & { name?: string } & CMSBasePropertyNoName)
    | (Omit<RelationProperty, "name"> & { name?: string } & CMSBasePropertyNoName)
    | (Omit<ArrayProperty, "name" | "of" | "oneOf"> & {
        name?: string;
        of?: ConfigProperty | ConfigProperty[];
        oneOf?: { properties: Record<string, ConfigProperty>; typeField?: string; valueField?: string; propertiesOrder?: string[] }
    } & CMSBasePropertyNoName)
    | (Omit<MapProperty, "name" | "properties"> & {
        name?: string;
        properties?: Record<string, ConfigProperty>
    } & CMSBasePropertyNoName)
    | (Omit<VectorProperty, "name"> & { name?: string } & CMSBasePropertyNoName)
    | (Omit<BinaryProperty, "name"> & { name?: string } & CMSBasePropertyNoName);

/**
 * This is the configuration object for a property.
 * These configs are generated by default for the properties defined in your
 * collections' configuration, but you can define your own to be used.
 */
export type PropertyConfig = {

    /**
     * Key used to identify this property config.
     */
    key: PropertyConfigId | string;

    /**
     * Name of this field type.
     * This is not the name of the property.
     */
    name: string;

    /**
     * Default config for the property.
     * This property or builder will be used as the base values for the resulting property.
     * You can also use a builder function to generate the base property.
     */
    property: ConfigProperty;

    /**
     * Optional icon to be used in the field selector.
     * Use a 24x24 component, in order not to break the layout.
     * Any Rebase icon can be used.
     */
    Icon?: React.ComponentType;

    /**
     * CSS color, used only in some plugins like the field selector.
     * e.g. "#2d7ff9"
     */
    color?: string;

    /**
     * Description of this field type.
     */
    description?: string;

}

export type PropertyConfigId =
    "text_field" |
    "multiline" |
    "markdown" |
    "url" |
    "email" |
    "user_select" |
    "select" |
    "multi_select" |
    "number_input" |
    "number_select" |
    "multi_number_select" |
    "file_upload" |
    "multi_file_upload" |
    "group" |
    "key_value" |
    "reference" |
    "multi_references" |
    "relation" |
    "switch" |
    "date_time" |
    "repeat" |
    "custom_array" |
    "block" |
    "vector_input";
